export default __webpack_public_path__ + "2b4c08e5e98583fa5e4e17fa301d9190.woff";